import { Provider } from '@angular/core';
import { TIPO_DOCUMENTAL_REPOSITORY } from './repositories/tipo-documental.repository';
import { TipoDocumentalService } from './services/tipo-documental.service';

export const TIPO_DOCUMENTAL_PROVIDERS: Provider[] = [
  {
    provide: TIPO_DOCUMENTAL_REPOSITORY,
    useClass: TipoDocumentalService
  }
];


